export const useImageSize = ({ refImage, rounded }: { refImage: any; rounded: any }) => {
  let imageSize;

  if (refImage.current) {
    const rect = refImage.current.getBoundingClientRect();
    const imageWidth = 260;
    const imageHeight = (260 * rect.height) / rect.width;

    let left = rect.right - imageWidth;
    let top = rect.top - imageHeight;
    if (rounded) {
      left -= rect.width / 2;
      top += rect.width / 2;
    } else {
      top -= 4;
    }
    if (top < 0) {
      top = rect.top + rect.height;
      if (rounded) {
        top -= rect.width / 2;
      } else {
        top += 4;
      }
    }
    if (left < 0) {
      left = rect.left;
      if (rounded) {
        left += rect.width / 2;
      }
    }

    imageSize = {
      width: imageWidth,
      height: imageHeight,
    };
  }
  return { imageSize };
};
